export default "__VITE_ASSET__BuDG1CjQ__"